module.exports = __webpack_public_path__ + "static/media/agregatusproductos-asset.2396a99d.png";